import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_andrich-care/artifacts/byrie1sq_WhatsApp%20Image%202026-07-13%20at%204.57.32%20PM.jpeg";

export function AndrichLogo({ className = "", variant = "default" }) {
  const showSubtitle = variant !== "compact";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="andrich-logo">
      <img
        src={LOGO_URL}
        alt="Andrich Pharmaceuticals"
        className="h-11 w-auto object-contain select-none"
        style={{ mixBlendMode: "multiply" }}
        draggable="false"
      />
      {showSubtitle && (
        <div className="hidden sm:block leading-tight">
          <div className="text-[0.62rem] font-medium tracking-[0.22em] text-slate-500 uppercase">
            Pharmaceuticals Pvt. Ltd.
          </div>
        </div>
      )}
    </div>
  );
}
